module.exports = __webpack_public_path__ + "static/media/image-frame.25b2111a.png";